export const GET_MONITOR_DATA = 'get-monitor-data';
